import React from 'react';
import './user-ranking.scss';

const RankingUser = ({star_summary, rating_base_ten, rating_base_five, collapse, ps}) => {
    if (!star_summary || star_summary.size === 0) {
        return null;
    }

    let counter = 0;

    return (
        <div className="reviews-header-stars cf">
            {ps.isMobileResponsive && !collapse &&
                <div>
                    <span className="rating-category average m-r-5">
                        {i18n.t('reviews.users.user_show.average_rating')}
                        <span className="total-rating-out-five p-l-5">({rating_base_five})</span>
                    </span>
                    <span className={`star-rating-s15 rate-${rating_base_ten} rf`}></span>
                </div>
            }
            {star_summary.toArray().map((value, index) => {
                counter++;
                return (
                    <div key={index}>
                        <div className="rating-category">{i18n.t(`reviews.gigs._rating.q${counter}`)}</div>
                        <span className={`star-rating-s15 rate-${value}`}></span>
                    </div>
                );
            })}
        </div>
    );
};

export default RankingUser;



// WEBPACK FOOTER //
// ./src/reviews/user_ranking/RankingUser.js